<template>
  <section class="persons-block">
    <header class="persons-block__header">
      <h2 class="persons-block__title">
        {{ data.title }}
      </h2>
    </header>
    <div v-if="computedPublishedPersons" class="persons-block__inner">
      <swiper
          slides-per-view="auto"
          class="persons-block__slider"
          :watch-overflow="true"
          @swiper="useSwiper"
      >
        <swiper-slide
            v-for="(personItem) in computedPublishedPersons"
            :key="`person-item_${personItem.person_page.id}`"
            class="persons-block__slider-slide"
        >
          <AppPersonCard :data="personItem.person_page"/>
        </swiper-slide>

        <AppSwiperControls>
          <AppButton
              v-if="showPageBtn"
              :url="`/people/${joinSlugId(data.people_page)}`"
              :title="computedLabel"
              :end-icon="true"
          >
            {{ computedLabel }}
          </AppButton>
        </AppSwiperControls>
      </swiper>
    </div>
  </section>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import {TPersonItem, TPersonsBlock} from '~/types/block-types'
import {TPeoplePage} from '~/types/page-types'
import {joinSlugId} from "~/utils/slug-id";
import {useSwiper} from "~/composables/useSwiper";

const props = defineProps<{
  data: TPersonsBlock,
}>()

// only show published person pages
const computedPublishedPersons = computed(() => {
  if (Array.isArray(props.data.persons)) {
    return Array.from(props.data.persons).filter((item: TPersonItem) => {
      if (item.person_page && typeof item.person_page !== 'number' && 'status' in item.person_page) {
        return item.person_page?.status === 'published'
      } else {
        return false
      }
    })
  }
})

const computedLabel = computed(() => {
  return props.data.button_label || 'lees meer'
})

const showPageBtn = computed(() => {
  const page = props.data.people_page as TPeoplePage
  return (page && page.status === 'published')
})

</script>

<style scoped lang="postcss">
.persons-block {
  position: relative;
  padding-bottom: 5rem;
  color: var(--color-blue-aqua);

  &__header {
    @mixin container;
    @mixin app-container-padding;
    @mixin app-grid;
    @mixin app-content-block-title-margins;
  }

  &__title {
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;
    text-align: center;
    @mixin heading-h1-xl;
  }

  &__inner {
    overflow: clip;
  }

  &__slider {
    overflow: visible;
  }

  &__slider-slide {
    position: relative;
    margin-right: 1.25rem;
    width: fit-content;

    @media (--md) {
      margin-right: 1.5rem;

      &:first-child {
        margin-left: 1rem;
      }
    }
  }
}
</style>
